module.exports = __webpack_public_path__ + "img/item_image_4.12d8ebd5.jpg";